import { connect } from 'react-redux'
import {
  pageToggleOverlay,
  setPrecedentAdminFiles,
  setPrecedentId,
  submitPrecedentAdminForm,
  updatePrecedentAdminState,
  setPrecedentSectionId,
  setPrecedentsView,
  resetPrecedentAdminState,
  setPrecedentAdminParents
} from 'redux/actions'
import PrecedentsAdmin from 'pages/documentscontent/precedentsadmin/PrecedentsAdmin'

const mapStateToProps = state => ({
  isUpdateMode: state.precedents.admin.isUpdateMode,
  files: state.precedents.admin.files,
  fileName: state.precedents.admin.fileName,
  title: state.precedents.admin.title,
  parentId: state.precedents.admin.parentId,
  precedentId: state.precedents.precedentId
})

const mapDispatchToProps = dispatch => ({
  pageToggleOverlay: (component) => dispatch(pageToggleOverlay(component)),
  setPrecedentId: precedentId => dispatch(setPrecedentId(precedentId)),
  setView: view => dispatch(setPrecedentsView(view)),
  setFiles: files => dispatch(setPrecedentAdminFiles(files)),
  setParents: parents => dispatch(setPrecedentAdminParents(parents)),
  setSectionId: sectionId => dispatch(setPrecedentSectionId(sectionId)),
  submitForm: () => dispatch(submitPrecedentAdminForm()),
  updateState: () => dispatch(updatePrecedentAdminState()),
  resetState: () => dispatch(resetPrecedentAdminState())
})

export default connect(mapStateToProps, mapDispatchToProps)(PrecedentsAdmin)
